import { render, staticRenderFns } from "./ProdutosPorMarca.vue?vue&type=template&id=767fd1f9&scoped=true&"
import script from "./ProdutosPorMarca.vue?vue&type=script&lang=js&"
export * from "./ProdutosPorMarca.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosPorMarca.vue?vue&type=style&index=0&id=767fd1f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fd1f9",
  null
  
)

export default component.exports